var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-header"},[_c('div',{staticClass:"main-header-logo"},[_c('router-link',{staticClass:"logoLink",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/logo.png"),"alt":""}}),_vm._v(" 湖北长江互联网教育研究院职业技能等级考试系统 ")])],1),_c('div',{staticClass:"main-header-main"},[_c('user-dropdown')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }